import React, { Component } from 'react';
import Alert from 'components/alerts/Alert/Alert';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { change, reduxForm, SubmissionError } from 'redux-form';
import { showSnackBar } from 'actions/globalActions';
import { getTimezones } from 'actions/Teacher/timezoneActions';
import { trimUserInput } from 'utils/formHelpers';
import { updateProfile } from 'actions/userActions';

import GeneralInformation from './GeneralInformation';
import Languages from './Languages';

import './style.css';

class TeacherSettingsProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      languages: props.user.languages.map(language => ({
        serviceId: language.service.id,
        skillLevelId: language.skillLevel.id
      }))
    };
  }

  componentDidMount() {
    this.props.getTimezones();
  }

  selectDetectedTimezone = (detectedTimezone) => {
    this.props.change('information.timezone', detectedTimezone);
  }

  handleChangeLanguage = (selectedIndex, field, value) => {
    this.setState({
      languages: this.state.languages.map((item, index) => (index === selectedIndex ?
        { ...item, [field]: value } : item))
    });
  }

  handleAddLanguage = () => {
    this.setState({
      languages: [...this.state.languages, { serviceId: '', skillLevelId: '' }]
    });
  }

  handleRemoveLanguage = (selectedIndex) => {
    this.setState({
      languages: this.state.languages.filter((item, index) => index !== selectedIndex)
    });
  }

  checkLanguageChanged = () => {
    const {
      user: { languages }
    } = this.props;
    const prevLanguages = languages.map(language => ({
      serviceId: language.service.id,
      skillLevelId: language.skillLevel.id
    }));
    const filteredLanguages = this.state.languages.filter(
      item => item.serviceId !== '' && item.skillLevelId !== ''
    );
    return !isEqual(sortBy(prevLanguages), sortBy(filteredLanguages));
  }

  handleFormSubmit = (values) => {
    const userInput = trimUserInput(values);
    const { languages } = this.state;
    const {
      showSnackBar: showSnackBarFn,
    } = this.props;
    const {
      familyName, givenName, information, skypeName
    } = userInput;
    const name = `${givenName} ${familyName}`;

    // @todo - Should a promise returns resolve sometime?
    return new Promise(() => {
      this.props.updateProfile(
        {
          familyName,
          givenName,
          name,
          information,
          skypeName,
          languages
        },
        false,
        () => {
          showSnackBarFn();
        }
      );
    }).catch(ex => {
      throw new SubmissionError(ex);
    });
  }

  handleCancel = () => {
    this.props.reset();

    const {
      user: { languages }
    } = this.props;

    // TODO: Is this some sort of hack? Not sure why when we reset we repopulate this field
    this.setState({
      languages: languages.map(language => ({
        serviceId: language.service.id,
        skillLevelId: language.skillLevel.id
      }))
    });
  }

  renderFormError(error) {
    return (
      <Alert className="UpdateUserProfileFormError mb-4" alertType="danger">
        {// if the error is a string, return it,
        // otherwise build the error message
          typeof error === 'string' ? error : `${error.status}: ${error.statusText}`
        }
      </Alert>
    );
  }

  render() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;

    return (
      <form
        className="teacher-settings-profile full-height d-flex flex-column"
        onSubmit={handleSubmit(this.handleFormSubmit)}
      >
        {// if an error exists, render an Alert
          error && this.renderFormError(error)
        }

        <div className="teacher-settings-profile__content p-0 pr-md-4">
          <GeneralInformation
            curTimezone={get(this.props, 'user.information.timezone')}
            timezones={this.props.timezones}
            selectDetectedTimezone={this.selectDetectedTimezone}
          />
          <Languages
            languages={this.state.languages}
            onAdd={this.handleAddLanguage}
            onChange={this.handleChangeLanguage}
            onRemove={this.handleRemoveLanguage}
          />
        </div>
        <div className="teacher-settings-profile__footer d-flex px-4 px-lg-5 py-4">
          <button
            type="submit"
            className="btn btn-primary btn-lg btn-blue btn-cursor btn-teacher-dashboard"
            disabled={(pristine && !this.checkLanguageChanged()) || submitting}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-lg btn-cursor btn-teacher-dashboard ml-2"
            onClick={this.handleCancel}
            disabled={submitting}
          >
            Cancel
          </button>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  const rypeProfile = get(state, 'user.profile', {});
  return {
    user: get(state, 'user.profile'),
    teacher: state.teacher.teacher,
    timezones: state.teacher.timezones,
    initialValues: {
      givenName: rypeProfile.givenName,
      familyName: rypeProfile.familyName,
      email: rypeProfile.email,
      skypeName: rypeProfile.skypeName,
      information: {
        countryISO: get(rypeProfile, 'information.countryISO'),
        city: get(rypeProfile, 'information.city'),
        description: get(rypeProfile, 'information.description'),
        timezone: get(rypeProfile, 'information.timezone')
      }
    }
  };
}

const validate = values => {
  const errors = { information: {} };

  if (!values.givenName) {
    errors.givenName = 'Required';
  }

  if (!values.familyName) {
    errors.familyName = 'Required';
  }

  if (!values.skypeName) {
    errors.skypeName = 'Required';
  }

  if (!values.information.description) {
    errors.information.description = 'Required';
  }

  return errors;
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ change }, dispatch);
};

export default compose(
  connect(
    mapStateToProps,
    {
      updateProfile,
      showSnackBar,
      getTimezones,
      mapDispatchToProps
    }
  ),
  reduxForm({
    form: 'teacherProfileForm',
    enableReinitialize: true,
    validate
  })
)(TeacherSettingsProfile);



// WEBPACK FOOTER //
// ./src/pages/teacher/Settings/Profile/index.js